export default function(state = {}, action) {
  const typeMap = {
    RECOGNITION_HUB_PAGE_LOADING() {
      return {
        isLoading: true,
        recognitionHubPage: action.recognitionHubPage
      };
    },
    RECOGNITION_HUB_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.recognitionHubPage
      };
    },
    RECOGNITION_HUB_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.recognitionHubPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
